import React, { useState } from 'react';

// posicao: "topo" (acima da tabela) ou "rodape" (dentro da tabela, no fim)
export default function Paginacao({ pagina, totalPaginas, total, porPagina, carregando, onMudar, posicao = 'rodape' }) {
  const [irPara, setIrPara] = useState('');
  const inicio = total ? (pagina - 1) * porPagina + 1 : 0;
  const fim = Math.min(pagina * porPagina, total);
  const idCampo = `cx-ir-para-${posicao}`;

  const ir = (e) => {
    e.preventDefault();
    const numero = parseInt(irPara, 10);
    if (!isNaN(numero) && numero >= 1 && numero <= totalPaginas) {
      onMudar(numero);
      setIrPara('');
    }
  };

  return (
    <div className={posicao === 'topo' ? 'cx-barra-paginacao' : 'cx-rodape-tabela'}>
      <span className="cx-num">
        {inicio.toLocaleString('pt-BR')}–{fim.toLocaleString('pt-BR')} de {total.toLocaleString('pt-BR')} cursos · Página {pagina} de {Math.max(totalPaginas, 1)}
      </span>
      {totalPaginas > 1 && (
        <form className="cx-paginacao" onSubmit={ir}>
          <button type="button" className="cx-btn cx-mini" disabled={carregando || pagina <= 1} onClick={() => onMudar(1)}>«</button>
          <button type="button" className="cx-btn cx-mini" disabled={carregando || pagina <= 1} onClick={() => onMudar(pagina - 1)}>‹ Anterior</button>
          <button type="button" className="cx-btn cx-mini" disabled={carregando || pagina >= totalPaginas} onClick={() => onMudar(pagina + 1)}>Próxima ›</button>
          <button type="button" className="cx-btn cx-mini" disabled={carregando || pagina >= totalPaginas} onClick={() => onMudar(totalPaginas)}>»</button>
          <label className="cx-dica" htmlFor={idCampo} style={{ margin: 0 }}>Ir para</label>
          <input id={idCampo} type="number" min="1" max={totalPaginas} value={irPara} onChange={(e) => setIrPara(e.target.value)} />
          <button type="submit" className="cx-btn cx-mini" disabled={carregando}>Ir</button>
        </form>
      )}
    </div>
  );
}
